import { render, staticRenderFns } from "./HistoricoGestion.vue?vue&type=template&id=b767506c&"
import script from "./HistoricoGestion.vue?vue&type=script&lang=js&"
export * from "./HistoricoGestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports